import { useAxios } from '../Plugins/axios';
import { useSpinner } from '../Plugins/spinner';
import { useRoute } from '../Plugins/ziggy';
export default class SoilDataService {
    axios;
    route;
    spinner;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
        this.spinner = useSpinner();
    }
    getById(id) {
        this.spinner.show();
        return this.axios
            .get(this.route('api.soil-data.show', [id]))
            .then((response) => response.data.data)
            .finally(() => this.spinner.hide());
    }
}
